import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import noteList from "./components/note-list.vue";
import noteEdit from "./components/note-edit.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const state = ref(0);
    const ID = ref(-1);
    async function changeState(params) {
      console.log(params, "params");
      if (params) {
        ID.value = params;
      }
      state.value = 1;
    }
    async function changes() {
      state.value = 0;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [state.value == 0 ? (_openBlock(), _createBlock(noteList, {
        key: 0,
        onPubsnote: changeState
      })) : _createCommentVNode("", true), state.value == 1 ? (_openBlock(), _createBlock(noteEdit, {
        key: 1,
        id: ID.value,
        onPubsnote: changes
      }, null, 8, ["id"])) : _createCommentVNode("", true)]);
    };
  }
});